import { styled } from "styled-components";

export const RelatedQuestions = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FeatureDescriptionSectionWrapper = styled.div`
  display: flex;
  max-width: 100%;
  width: 100%;
  justify-content: center;
  position: relative;
`;

export const FeatureDescriptionSectionContainer = styled.div`
  display: flex;
  gap: 48px;
  max-width: ${(props) => props.theme.content.maxWidth}px;
  padding: 96px 24px 96px 24px;

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
    padding: 80px 24px 96px 24px;
  }
`;

export const FeaturesSideMenuWrapper = styled.div`
  width: 375px;
  padding: 24px 0px;
  height: 100%;
  ${({ theme }) => theme.breakpoints.md.query} {
    width: 100%;
  }
`;

export const MainContainer = styled.div`
  display: flex;
  gap: 48px;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 100%;
  padding: 24px;

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
    padding: 0px;
  }
`;

export const FeatureDescriptionHeader = styled.div`
  display: flex;
  padding: 48px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  background-color: ${(props) => props.theme.colors.primary[950]};
  color: ${(props) => props.theme.colors.primary[50]};
  border-radius: 16px;
`;

export const ButtonGroup = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

export const FeatureDescriptionBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  align-self: stretch;
`;

export const FeatureDescriptionText = styled.div`
    display: flex;
    flex-direction: column;



    & > h2 {

    margin-bottom: 16px;
    margin-top: 36px;

    }

    & > p {
        color: var(--night-rider-600, #625B58);

    font-size: 17px;
    font-style: normal;
    font-weight: 550;
    line-height: 150%; /* 25.5px */
    margin-bottom: 16px;
    & > a {
        color: ${(props) => props.theme.colors.primary[500]};
    }
`;

export const FeatureDescriptionBullets = styled.div<{ $newFormat?: boolean }>`
  background: ${({ theme, $newFormat }) =>
          $newFormat ? theme.colors.base : theme.colors.default[50]};
  height: fit-content;
  display: flex;
  padding: ${({ $newFormat }) => ($newFormat ? "0px" : "24px")};
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  border-radius: 12px;

  & > h2 {
    padding-bottom: 12px;
  }
`;

export const VideoFrameContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 12px;
  overflow: hidden;
`;
